/*
 * Sticky bar "Poruči odmah" (id="SectionAtcBtn-{{ section.id }}") on product
 * pages. The theme wires it to "add to cart + open the cart drawer". Instead it
 * opens the SAME Releasit COD form as the big green "Poruči odmah" button on
 * the page (._rsi-buy-now-button-product), with the variant chosen there.
 * If Releasit's button is not on the page, the theme's own behaviour stays.
 * (Older versions targeted #rsi_buy_now_button from Releasit's newer engine;
 * this store runs the legacy engine, where that id never exists.)
 *
 * Also: paints the sticky button green with the same cart icon (styles in
 * releasit-override.css) and publishes the sticky bar height as
 * --bk-sticky-h so the footer can leave room for it.
 */
(function () {
  var RELEASIT_PRODUCT_BTN = '._rsi-buy-now-button-product';
  var ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" class="bk-sticky-icon"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg>';

  function mainReleasitButton() {
    var all = Array.prototype.filter.call(document.querySelectorAll(RELEASIT_PRODUCT_BTN), function (el) {
      return !el.closest('#CartDrawer, cart-drawer, .card-wrapper, .quick-add, .quick-add-modal, sticky-atc');
    });
    return (
      all.find(function (el) {
        return el.offsetParent !== null;
      }) || all[0] || null
    );
  }

  document.addEventListener(
    'click',
    function (e) {
      var stickyTrigger = e.target.closest('[id^="SectionAtcBtn-"]');
      if (!stickyTrigger) return;
      var rsi = mainReleasitButton();
      if (!rsi) return; // Releasit not mounted: keep the theme's add-to-cart
      e.preventDefault();
      e.stopImmediatePropagation();
      rsi.click();
    },
    true
  );

  function decorateSticky() {
    document.querySelectorAll('[id^="SectionAtcBtn-"]').forEach(function (btn) {
      if (!btn.classList.contains('bk-sticky-buy')) btn.classList.add('bk-sticky-buy');
      var label = btn.querySelector('.sticky-atc__label');
      if (label && !label.querySelector('.bk-sticky-icon')) label.insertAdjacentHTML('afterbegin', ICON);
    });
  }

  function syncStickyHeight() {
    var box = document.querySelector('sticky-atc .sticky-atc-container');
    var h = box ? Math.ceil(box.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--bk-sticky-h', h + 'px');
  }

  function initSticky() {
    decorateSticky();
    syncStickyHeight();
    var box = document.querySelector('sticky-atc .sticky-atc-container');
    if (box && window.ResizeObserver) new ResizeObserver(syncStickyHeight).observe(box);
    var sticky = document.querySelector('sticky-atc');
    if (sticky) new MutationObserver(decorateSticky).observe(sticky, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky);
  } else {
    initSticky();
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('.releasit-cart-page-button')) redirectToCartCheckout(e);
    },
    true
  );

  // Cart-aware Releasit button inside the cart drawer (used by the /cart
  // page fallback button below).
  function redirectToCartCheckout(e) {
    var drawer = document.getElementById('CartDrawer');
    var btn = drawer && drawer.querySelector('._rsi-buy-now-button-cart, #rsi_buy_now_button');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.click();
  }

  // Standalone /cart page: the native "#checkout" button is hidden via CSS
  // (releasit-override.css) — inject a visible Releasit-driven replacement
  // right after it, styled to match the brand's other buy buttons.
  function injectCartPageButton() {
    var nativeBtn = document.getElementById('checkout');
    if (!nativeBtn || document.querySelector('.releasit-cart-page-button')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'releasit-cart-page-button';
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
      '<span>Poruči odmah</span>';
    nativeBtn.insertAdjacentElement('afterend', btn);
  }

  // Releasit now renders its own cart-page button (._rsi-buy-now-button-cart).
  // Only add ours if Releasit's hasn't appeared, and drop ours once it does,
  // so the cart never shows two "Poruči odmah" buttons.
  var RELEASIT_CART_BTN = '._rsi-buy-now-button-cart';
  function releasitCartButtonOnPage() {
    return Array.prototype.some.call(document.querySelectorAll(RELEASIT_CART_BTN), function (el) {
      return !el.closest('#CartDrawer');
    });
  }
  function syncCartPageButton() {
    var ours = document.querySelector('.releasit-cart-page-button');
    if (releasitCartButtonOnPage()) {
      if (ours) ours.remove();
    } else if (!ours) {
      injectCartPageButton();
    }
  }
  if (document.getElementById('checkout')) {
    setTimeout(syncCartPageButton, 3000);
    new MutationObserver(function () {
      if (releasitCartButtonOnPage() && document.querySelector('.releasit-cart-page-button')) syncCartPageButton();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
